/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getByThemePathAndBusinessUnitIdRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'getByThemePathAndBusinessUnitId',
  auth: 'app',
  fingerprint: '65_WmYbGttx66VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'list',
  auth: 'app',
  fingerprint: 'UzyQRVHqhh0P8TnwG-Be0JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'fX_G2xkuE7566VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'fX_G2xkuE7566VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: '65_WmYbGttzBIV0pXcghjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};